{
  "account_disconnected": "Account disconnected successfully",
  "active_switch": "Enable synchronization",
  "active_switch_description": "Switch this on to start syncing with provider",
  "add_another_account": "Add another account",
  "available_integrations": "Available integrations",
  "connect": "Connect",
  "connected_integrations": "Connected integrations",
  "demo_email_delivery_description": "Emails are not delivered to recipients in the demo environment. They are redirected to the internal Mailpit inbox.",
  "demo_email_delivery_title": "Email delivery is redirected on demo",
  "demo_http_workflow_description": "Outbound HTTP requests are disabled in the demo environment. Running a flow with this block will fail.",
  "demo_http_workflow_title": "HTTP flow blocks are unavailable on demo",
  "demo_slack_notifications_description": "Slack notification channels are unavailable in the demo environment. You can configure them, but notifications will not be delivered.",
  "demo_slack_notifications_title": "Slack notifications are unavailable on demo",
  "demo_unavailable_description": "External integrations cannot be connected in the demo environment.",
  "demo_unavailable_tag": "Unavailable on demo",
  "demo_webhooks_description": "Outbound webhook deliveries are disabled in the demo environment. You can configure webhooks, but requests will not be sent.",
  "demo_webhooks_title": "Webhook delivery is unavailable on demo",
  "disconnect": "Disconnect",
  "disconnect_confirm": "Disconnect integration?",
  "employee_link_status_linked": "Linked",
  "employee_link_status_not_found": "Not found",
  "employees_not_found_count": "Not found: {count}",
  "from_slack": "From Slack",
  "gmail_account": "Gmail account",
  "google_calendar_active_switch": "Enable syncing with Google Calendar",
  "google_calendar_active_switch_description": "Switch this on to start syncing your %APP_NAME% events with Google Calendar automatically",
  "google_calendar_credentials": "Paste Google API credentials",
  "google_calendar_credentials_description": "Enter the JSON credentials from your Google Cloud service account to enable the Google Calendar integration",
  "google_calendar_description": "Integration syncs events between %APP_NAME% and Google Calendar",
  "google_calendar_email": "Calendar email",
  "google_calendar_employees_not_found_description": "These employees aren't linked to Google Calendar: no calendar matched their work email. Check the email and run a sync",
  "google_calendar_identity": "Super admin email",
  "google_calendar_install_description": "Google Calendar is an essential productivity tool, and with this %APP_NAME% integration, you’ll never miss another important one-on-one meeting or interview. Once installed, any scheduled interviews or meetings in %APP_NAME% will automatically be synced to your Google Calendar, ensuring they’re visible and ready for you to manage.\n\nThis integration also adds a Google Meet link to each scheduled event, making it easier for you to join virtual meetings without the hassle of manually creating links.\n\nThis is a company-wide integration, automatically connecting the calendars of all employees whose emails match between your Workspace and %APP_NAME%.",
  "google_calendar_install_help": "For a detailed step-by-step guide,",
  "google_calendar_install_help_link": "click here for full instructions",
  "google_calendar_install_overview": "Overview",
  "google_calendar_sync_out_of_office_events_description": "Automatically block calendar and decline meetings when vacation requests are approved. Creates \"Out of Office\" events that prevent new meeting invitations and notify colleagues about absence.",
  "google_calendar_sync_out_of_office_events_title": "Google Calendar vacation sync",
  "google_calendar_title": "Google Calendar",
  "google_workspace_description": "Automatically create and manage employee corporate accounts",
  "google_workspace_not_connected": "Google Workspace not connected",
  "google_workspace_not_connected_description": "Connect your Google workspace to enable syncing",
  "google_workspace_title": "Google Workspace",
  "is_active": "Active",
  "last_synced": "Last synced",
  "manage": "Manage",
  "mcp_copy_address": "Copy address",
  "mcp_description": "Work with %APP_NAME% data from Claude, ChatGPT, Cursor, or VS Code. Add this server address to your AI client.",
  "mcp_how_to_connect": "How to connect",
  "mcp_organization_description": "Each employee connects Claude, ChatGPT, Cursor, or VS Code to their own account.",
  "mcp_title": "Claude and other AI clients",
  "not_active": "Inactive",
  "not_connected": "Not connected",
  "outlook_account": "Outlook account",
  "reconnect": "Reconnect",
  "settings_integrations_description": "Connect all your HR tools into one unified ecosystem",
  "settings_integrations_title": "Integrations",
  "slack_account_disconnect_confirm": "Disconnect Slack integration?",
  "slack_account_disconnect_confirm_description": "You will no longer receive Slack notifications and data sync will stop",
  "slack_active_switch": "Enable Slack synchronization",
  "slack_active_switch_description": "Switch this on to start syncing with Slack",
  "slack_description": "Get instant updates about team availability and manage leave requests directly from Slack",
  "slack_email": "Slack email",
  "slack_employees_not_found_description": "These employees aren't linked to Slack: no account matched their work email. Check the email and run a sync",
  "slack_name": "Slack name",
  "slack_not_connected": "Slack not connected",
  "slack_not_connected_description": "Connect your Slack workspace to enable syncing",
  "slack_reconnection_required_description": "We've updated the app permissions to improve functionality. Please reconnect Slack to continue syncing your data.",
  "slack_reconnection_required_title": "Slack reconnection required",
  "slack_sync_address_description": "Update Slack profile with employee’s address",
  "slack_sync_address_title": "Sync work location",
  "slack_sync_hired_on_description": "Add employee’s start date to Slack profile",
  "slack_sync_hired_on_title": "Sync start date",
  "slack_sync_name_description": "Use the name from %APP_NAME% as the Slack full name",
  "slack_sync_name_title": "Sync display name",
  "slack_sync_photo_description": "Update photo in %APP_NAME% using photo from Slack",
  "slack_sync_photo_title": "Sync profile photo",
  "slack_sync_position_description": "Keep Slack job title in sync with current role in %APP_NAME%",
  "slack_sync_position_division_description": "Show employee’s division from %APP_NAME% in Slack profile",
  "slack_sync_position_division_title": "Sync division",
  "slack_sync_position_title": "Sync job title",
  "slack_title": "Slack",
  "sync_now": "Sync now...",
  "sync_settings": "Sync settings",
  "sync_started": "Sync started. Statuses will update once it finishes",
  "to_slack": "To Slack",
  "zoom_connected": "Zoom connected",
  "zoom_connected_description": "Zoom meetings are created on behalf of the Zoom user with the organizer's email",
  "zoom_description": "Add Zoom links to meetings and interviews",
  "zoom_not_connected": "Zoom not connected",
  "zoom_not_connected_description": "Connect your company's Zoom account to add Zoom links to meetings. Only a Zoom account admin can connect it",
  "zoom_title": "Zoom",
  "~": "~"
}
